<template>
  <b-container id="listings-seo-content-block" class="pt-3 pb-5">
    <b-row>
      <b-col>
        <b-row>
          <b-col v-if="richContent" class="mt-4">
            <RichTextRenderer :document="richContent" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RichTextRenderer from 'contentful-rich-text-vue-renderer'

import { CONTENT_TYPES } from '@/constants/contentful.js'
export default {
  name: 'SEOContentBlock',
  components: {
    RichTextRenderer,
  },
  props: {
    homeType: {
      type: String,
      default: 'co_living',
    },
    market: {
      type: String,
      default: 'Bay Area',
    },
  },
  data() {
    return {
      richContent: '',
    }
  },
  async created() {
    try {
      const {
        items: [seoBlock],
      } = await this.$contentful.getEntries({
        content_type: CONTENT_TYPES.seoContentBlock,
        'fields.type': this.homeType,
        'fields.marketName': this.market,
      })

      this.richContent = seoBlock.fields.content
    } catch (ignoredError) {}
  },
}
</script>

<style lang="scss">
#listings-seo-content-block {
  // these have to be styled this way because they are in rich content and have no classes
  h3,
  h4 {
    font-family: $accent-font;
    font-size: 24px;
    line-height: 34px;
    font-weight: 700;
    margin: 20px 0;
  }
  h2 {
    font-family: $accent-font;
    font-size: 28px;
    line-height: 36px;
    font-weight: 700;
    margin: 40px 0;
  }

  p {
    font-family: $base-font;
    font-size: 18px;
    line-height: 22px;
  }

  strong {
    font-family: $base-font;
    display: block;
    margin: 20px 0 10px 0;
  }
}
</style>
